export const createEmptyContentItem = () => ({
	value: '',
	start_time: '',
	end_time: '',
})

export const normalizeContentItems = (value, { keepEmpty = false } = {}) => {
	if (!Array.isArray(value)) {
		if (typeof value === 'string' && value.trim()) {
			try {
				return normalizeContentItems(JSON.parse(value), { keepEmpty })
			} catch {
				return [{ value: value.trim(), start_time: '', end_time: '' }]
			}
		}
		return []
	}

	return value
		.map(item => {
			if (typeof item === 'string') {
				const trimmed = item.trim()
				if (!trimmed && !keepEmpty) return null
				return { value: trimmed, start_time: '', end_time: '' }
			}

			const normalized = {
				value: `${item?.value ?? item?.name ?? item?.label ?? ''}`.trim(),
				start_time: `${item?.start_time ?? item?.startTime ?? ''}`.trim(),
				end_time: `${item?.end_time ?? item?.endTime ?? ''}`.trim(),
			}

			if (!keepEmpty && !normalized.value && !normalized.start_time && !normalized.end_time) {
				return null
			}

			return normalized
		})
		.filter(Boolean)
}
